import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isUnavailabilityCreationRequestFailure() {
      return getState().request.isFailure;
    },
    isUnavailabilityCreationRequestPending() {
      return getState().request.isPending;
    },
    isUnavailabilityCreationRequestSuccess() {
      return getState().request.isSuccessful;
    },
    getUnavailabilityCreationError() {
      return getState().error;
    },
  };
}

export { createSelector };
